import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import RedWarningIcon from "../../../assets/icons/red-warning-with-bg.svg";
import CrossGreyIcon from "../../../assets/icons/cross-grey.svg";
import "./index.less";

interface SubscriptionCooldownWarningProps {
  remainingDays?: number;
}

const SubscriptionCooldownWarning: React.FC<SubscriptionCooldownWarningProps> = ({ remainingDays }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState<boolean>(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="subscription-cooldown-warning-container">
      <img src={CrossGreyIcon} className="subscription-cooldown-warning-close" alt="Close" onClick={handleClose} />
      <div className="subscription-cooldown-warning-content">
        <img src={RedWarningIcon} className="subscription-cooldown-warning-icon" alt="Warning" />
        <div className="subscription-cooldown-warning-text-container">
          <div className="subscription-cooldown-warning-title">{t("subscription-cooldown-warning-title", { remainingDays })}</div>
          <div className="subscription-cooldown-warning-description">{t("subscription-cooldown-warning-description")}</div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCooldownWarning;
